import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Gallery from "./components/Gallery";
import Home from "./pages/Home";
import About from "./pages/About";
import CVPage from "./pages/CV";
import Contact from "./pages/Contact";
import PressPage from "./pages/Press";
import AnimationIndex from "./pages/AnimationIndex";
import AnimationProject from "./pages/AnimationProject";
import { PAINTINGS, CARDS } from "./data/portfolio";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/animation" element={<AnimationIndex/>}/>
          <Route path="/animation/:slug" element={<AnimationProject/>}/>
          <Route path="/paintings" element={
            <Gallery
              title="Paintings"
              subtitle="Personal paintings — studies, film homages and explorations of light, mood and atmosphere."
              items={PAINTINGS}
              columns="md:grid-cols-2 lg:grid-cols-3"
            />
          }/>
          <Route path="/cards" element={
            <Gallery
              title="Cards"
              subtitle="Illustrations for Disney Lorcana — characters and locations painted for the Disney trading card game."
              items={CARDS}
              columns="sm:grid-cols-2 lg:grid-cols-3"
              fit="contain"
            />
          }/>
          <Route path="/about" element={<About/>}/>
          <Route path="/cv" element={<CVPage/>}/>
          <Route path="/press" element={<PressPage/>}/>
          <Route path="/contact" element={<Contact/>}/>
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
